module.exports = __webpack_public_path__ + "img/4.3668f190.webp";